import { faEnvelope, faLock, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { changeAuthenticated, setUser } from "Slices/theme/reducer";
import { useDispatch } from "react-redux";
import { handlingApi } from "units/handlingApi";
import { ClipLoader } from "react-spinners";

const SignUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [userData, setuserData] = React.useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
    confirmPassword: "",
    termsAccepted: true,
    disclaimer: Cookies.get("disclaimer"),
  });
  const [showForm, setShowForm] = React.useState(false);
  const [showFormLoader, setShowFormLoader] = React.useState(false);
  const signupTypeRef = useRef("withPassword");
  const [googleBtnDisabled, setGoogleBtnDisabled] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setuserData((prevData) => ({ ...prevData, [name]: value }));
  };

  const googleUserData = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setShowForm(true);
      setShowFormLoader(true);
      const url = `${apiBaseUrl}user/check-google-signup-user`;
      const data = { token: tokenResponse.access_token };
      const userInfo = await handlingApi({ url, method: "POST", data });

      if (userInfo.statusCode === 200) {
        setGoogleBtnDisabled(true);
        setuserData((prevData) => ({
          ...prevData,
          fName: userInfo.data.name.split(" ")[0],
          lName: userInfo.data.name.split(" ")[1],
          email: userInfo.data.email,
        }));
        setShowFormLoader(false);
      }
      if (userInfo.statusCode === 400) {
        toast.error(userInfo.message);
        setShowForm(false);
        setShowFormLoader(false);
      }
    },
    onError: (error) => {
      setGoogleBtnDisabled(false);
      toast.error("Google sign-in failed. Please try again.");
      console.log("Login Failed:", error);
      setShowForm(false);
      setShowFormLoader(false);
    },
  });

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const signupType = signupTypeRef.current;

    if (signupType === "withPassword") {
      if (userData.password.length < 4) {
        toast.error("The password must be at least 4 characters long.");
        return;
      }
      if (userData.password !== userData.confirmPassword) {
        toast.error("The confirmation password does not match.");
        return;
      }
      if (
        userData.password.length > 4 &&
        userData.password === userData.confirmPassword
      ) {
        handleCreateAccount();
        return;
      }
      toast.error("Please enter your password.");
      return;
    }

    handleCreateAccount();
  };

  const handleCreateAccount = async () => {
    setLoading(true);
    try {
      const url = `${apiBaseUrl}user/google-signup`;
      const data = userData;

      const res = await handlingApi({ url, method: "POST", data });

      if (res.statusCode === 200) {
        toast.success(res.message);
        Cookies.set("token", res.token);
        dispatch(changeAuthenticated(true));
        dispatch(setUser(res.user));
        localStorage.setItem("userData", JSON.stringify(res.user));
        navigate("/chatbot");
        setuserData({
          fName: "",
          lName: "",
          email: "",
          password: "",
          confirmPassword: "",
          termsAccepted: true,
          disclaimer: false,
        });
        setLoading(false);
      }

      if (res.statusCode === 400) {
        toast.error(res.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };
  return (
    <>
      <div className="dash-board-main-wrapper">
        <Container>
          <Row className="justify-content-center">
            <Col lg={5}>
              <div className="single-form-s-wrapper">
                <div className="head">
                  <span>Start your journey.</span>
                  <h5 className="title mb-2">Create an account.</h5>
                </div>
                {loading ? (
                  <>
                    <div className="d-flex align-items-center flex-column justify-content-center my-5 py-5">
                      <ClipLoader size={40} color="#00308f" />
                      <p className="mt-4 fw-bold fs-2">
                        Setting up your account takes a few seconds
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="body">
                      <button
                        className="sign-in-otherway mt-3"
                        onClick={googleUserData}
                        disabled={googleBtnDisabled}
                      >
                        <div className="single mt-0">
                          <div className="icon">
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.98918 10.878L3.36263 13.217L1.07258 13.2654C0.388195 11.996 0 10.5437 0 9.00034C0 7.50793 0.362953 6.10055 1.00631 4.86133H1.0068L3.04559 5.23511L3.9387 7.26166C3.75177 7.80661 3.64989 8.39161 3.64989 9.00034C3.64996 9.661 3.76963 10.294 3.98918 10.878Z"
                                fill="#FBBB00"
                              ></path>
                              <path
                                d="M17.8422 7.31836C17.9455 7.86279 17.9994 8.42504 17.9994 8.99967C17.9994 9.64402 17.9317 10.2725 17.8026 10.8788C17.3645 12.9419 16.2197 14.7434 14.6338 16.0182L14.6333 16.0177L12.0654 15.8867L11.7019 13.6179C12.7542 13.0007 13.5766 12.035 14.0098 10.8788H9.19727V7.31836H17.8422Z"
                                fill="#518EF8"
                              ></path>
                              <path
                                d="M14.6336 16.0173L14.6341 16.0178C13.0917 17.2575 11.1325 17.9993 8.99968 17.9993C5.57227 17.9993 2.59239 16.0836 1.07227 13.2644L3.98886 10.877C4.74891 12.9054 6.70567 14.3494 8.99968 14.3494C9.98571 14.3494 10.9095 14.0828 11.7021 13.6175L14.6336 16.0173Z"
                                fill="#28B446"
                              ></path>
                              <path
                                d="M14.7442 2.07197L11.8286 4.45894C11.0082 3.94615 10.0385 3.64992 8.99955 3.64992C6.65361 3.64992 4.66025 5.16013 3.93828 7.26131L1.00635 4.86098H1.00586C2.50373 1.97307 5.52119 0 8.99955 0C11.1833 0 13.1855 0.777867 14.7442 2.07197Z"
                                fill="#F14336"
                              ></path>
                            </svg>
                          </div>
                          <p className="mt-0">Sign Up With Google</p>
                        </div>
                      </button>
                      {showForm &&
                        (showFormLoader ? (
                          <>
                            <div className="d-flex align-items-center flex-column justify-content-center my-5 py-5">
                              <ClipLoader size={40} color="#00308f" />
                            </div>
                          </> // Or a spinner/loader here if you want
                        ) : (
                          <>
                            <form onSubmit={handleFormSubmit} className="mt-4">
                              {/* Your form content here */}
                              <div className="row">
                                {/* First Name */}
                                <div className="col-lg-6">
                                  <div className="input-group mb-3 input-group-lg">
                                    <span className="input-group-text">
                                      <FontAwesomeIcon icon={faUser} />
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control m-0"
                                      placeholder="First Name"
                                      required
                                      value={userData.fName}
                                      name="fName"
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </div>
                                </div>

                                {/* Last Name */}
                                <div className="col-lg-6">
                                  <div className="input-group mb-3 input-group-lg">
                                    <span className="input-group-text">
                                      <FontAwesomeIcon icon={faUser} />
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control m-0"
                                      placeholder="Last Name"
                                      required
                                      value={userData.lName}
                                      name="lName"
                                      onChange={handleChange}
                                      readOnly
                                    />
                                  </div>
                                </div>

                                {/* Email */}
                                <div className="col-lg-12">
                                  <div className="input-group mb-3 input-group-lg">
                                    <span className="input-group-text">
                                      <FontAwesomeIcon icon={faEnvelope} />
                                    </span>
                                    <input
                                      type="email"
                                      className="form-control m-0"
                                      placeholder="Email"
                                      required
                                      value={userData.email}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Password Fields */}
                              <div className="input-group mb-3 input-group-lg">
                                <span className="input-group-text">
                                  <FontAwesomeIcon icon={faLock} />
                                </span>
                                <input
                                  type="password"
                                  className="form-control m-0"
                                  placeholder="Password"
                                  value={userData.password}
                                  name="password"
                                  onChange={handleChange}
                                />
                              </div>
                              <div className="input-group mb-3 input-group-lg">
                                <span className="input-group-text">
                                  <FontAwesomeIcon icon={faLock} />
                                </span>
                                <input
                                  type="password"
                                  className="form-control m-0"
                                  placeholder="Confirm Password"
                                  value={userData.confirmPassword}
                                  name="confirmPassword"
                                  onChange={handleChange}
                                />
                              </div>

                              {/* Terms Checkbox */}
                              {/* <div className="check-wrapper">
                                <div className="form-check d-flex align-items-start ps-1">
                                  <input
                                    className=""
                                    type="checkbox"
                                    id="flexCheckDefault"
                                    required
                                    checked={userData.termsAccepted}
                                    onChange={(e) =>
                                      setuserData({
                                        ...userData,
                                        termsAccepted: e.target.checked,
                                      })
                                    }
                                  />
                                  <label
                                    className="form-check-label text-start"
                                    htmlFor="flexCheckDefault"
                                  >
                                    I have read the{" "}
                                    <Link to="/terms-conditions">
                                      General Terms and Conditions of Use
                                    </Link>{" "}
                                    and agree to their validity. I confirm that
                                    I am of legal age.
                                  </label>
                                </div>
                              </div> */}

                              {/* Buttons */}
                              {!userData.password.length > 0 && (
                                <button
                                  type="submit"
                                  className="rts-btn btn-primary"
                                  onClick={() =>
                                    (signupTypeRef.current = "noPassword")
                                  }
                                >
                                  Sign Up Without Password
                                </button>
                              )}

                              <button
                                type="submit"
                                style={{ background: "rgb(45 41 50)" }}
                                className="rts-btn btn-primary mt-4"
                                onClick={() =>
                                  (signupTypeRef.current = "withPassword")
                                }
                              >
                                Sign Up With Password
                              </button>
                            </form>
                          </>
                        ))}
                    </div>
                  </>
                )}
                <p className="mt-4">
                  If you have an account?{" "}
                  <Link className="ml--5 text-primary" to="/login">
                    Log in
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SignUp;
